import { FormProvider } from 'react-hook-form';
import FormBuilderWithLayout from '@/components/company/FormBuilderWithLayout';

interface PunishmentFormProps {
  formControl: any;
  formRef: React.RefObject<HTMLFormElement>;
  fields: any[];
  formMode: 'add' | 'edit';
  handleSave: () => void;
  reset: () => void;
  setFormMode: (mode: 'add' | 'edit' | null) => void;
}

export const PunishmentForm = ({
  formControl,
  formRef,
  fields,
  formMode,
  handleSave,
  reset,
  setFormMode,
}: PunishmentFormProps) => (
  <FormProvider {...formControl}>
    <form ref={formRef} onSubmit={formControl.handleSubmit(handleSave)} className="mt-4">
      <FormBuilderWithLayout
        description={formMode === 'add' ? 'Create Punishment' : 'Edit Punishment'}
        fields={fields}
        onSubmit={formControl.handleSubmit(handleSave)}
        onCancel={() => {
          setFormMode(null);
        }}
        submitLabel={formMode === 'add' ? 'Save' : 'Update'}
        cancelLabel="Cancel"
        showPublishButton
      />
    </form>
  </FormProvider>
);
